import { APIError } from "../../api/utils/errors";

const TRANSIENT_CODES = new Set([
  "auth/network-request-failed",
  "auth/too-many-requests",
  "auth/internal-error",
  "unavailable",
  "deadline-exceeded"
]);

/**
 * Whether an error during session bootstrap is worth retrying rather than
 * ending the session. `handleAPIError` maps responseless network failures to
 * status 500, so they count as transient alongside real 5xx responses.
 */
export const isTransientAuthError = (err: unknown): boolean => {
  if (err instanceof APIError) return err.status >= 500;
  if (typeof err !== "object" || err === null || !("code" in err)) {
    return false;
  }
  const { code } = err as { code?: unknown };
  return typeof code === "string" && TRANSIENT_CODES.has(code);
};
